export enum SigningSessionStatus {
  DRAFT = 'DRAFT',

  SIGNED = 'SIGNED',

  EXPIRED = 'EXPIRED',

  CANCELLED = 'CANCELLED',
}
